import { apiPlansGetV2, planPageType } from 'api/plans/get';
import { getShopifyVariantResults } from 'lib/shopify/get-shopify-variants-direct';
import { Product } from 'entities/product';
import Home, { HomeProps } from 'components/home/home';
import { getHomepageContents } from 'lib/api';
import { PRODUCT_SKUS } from 'lib/constants/product-skus';

const getHomepageField = (homepageData: any, key: string) =>
  homepageData?.fields?.find((f: any) => f.key === key);

const getNestedFieldValue = (field: any, key: string): string | null =>
  field?.reference?.fields?.find((f: any) => f.key === key)?.value || null;

async function getHomepageProps({
  props,
  handle,
}: {
  props: any;
  handle?: string;
}) {
  try {
    const homepageResponse = await getHomepageContents(handle);
    const homepageData = homepageResponse?.data;

    if (!homepageData) {
      return;
    }

    props.homepageContent = homepageData;

    const heroField = getHomepageField(homepageData, 'hero');
    if (heroField?.reference) {
      props.heroSection = {
        id: heroField.reference.id,
        type: heroField.reference.type,
        desktopImageUrl: getNestedFieldValue(heroField, 'desktopimageurl'),
        mobileImageUrl: getNestedFieldValue(heroField, 'mobileimageurl'),
        title: getNestedFieldValue(heroField, 'title'),
        subtitle: getNestedFieldValue(heroField, 'subtitle'),
        primaryButtonText: getNestedFieldValue(heroField, 'primarybuttontext'),
        secondaryButtonText: getNestedFieldValue(
          heroField,
          'secondarybuttontext',
        ),
        primaryButtonUrl: getNestedFieldValue(heroField, 'primarybuttonurl'),
        secondaryButtonUrl: getNestedFieldValue(
          heroField,
          'secondarybuttonurl',
        ),
        primaryColor: getNestedFieldValue(heroField, 'primarycolor'),
      };
    }
  } catch (error) {
    console.error('Error fetching homepage contents:', error);
  }
}

interface PageIndexProps {
  heroSection?: HomeProps;
  homepageContent?: any;
}

const PageIndex = ({ heroSection }: PageIndexProps) => {
  return <Home {...heroSection} />;
};

export async function getStaticProps() {
  const products = (await apiPlansGetV2(planPageType.all)) as Product[];

  const props: any = {
    products,
  };

  const { results } = await getShopifyVariantResults({
    requiredSkus: [PRODUCT_SKUS.DAILY_SYNBIOTIC],
  });
  props.shopifyProducts = results;

  await getHomepageProps({
    props,
  });

  return {
    props,
    revalidate: 60 * 5, // 5 minutes in seconds. when we push to prod, update to one hour. it's this way now for testing purposes
  };
}

export default PageIndex;
